<template>
  <div class="app-container">
    <el-card>
      <div slot="header">
        <span><i class="el-icon-s-tools"></i> 班级管理</span>
      </div>

      <!-- 查询区域 -->
      <el-form
        :model="queryParams"
        label-position="right"
        label-width="70px"
        class="query-form"
        style="margin-bottom: 20px"
      >
        <el-row :gutter="20">
          <!-- 班级名称 -->
          <el-col :xs="24" :sm="12" :md="8" :lg="6">
            <el-form-item label="班级名称">
              <el-input
                v-model="queryParams.name"
                placeholder="请输入班级名称"
                clearable
                style="width: 100%"
              />
            </el-form-item>
          </el-col>
        </el-row>

        <!-- 按钮区域 -->
        <div>
          <el-button
            type="primary"
            icon="el-icon-search"
            @click="handleQuery(1)"
          >
            搜索
          </el-button>
          <el-button @click="resetQuery">重置</el-button>
          <el-button type="primary" @click="handleAdd"> 新增 </el-button>
          <el-button @click="downloadTemplate">下载模版</el-button>
        </div>
      </el-form>

      <!-- 表格区域 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        :cell-style="{ textAlign: 'center' }"
        :header-cell-style="{
          background: '#f5f7fa',
          color: '#333',
          fontWeight: 'bold',
          textAlign: 'center',
        }"
      >
        <el-table-column prop="gradeName" label="年级" fixed></el-table-column>
        <el-table-column prop="name" label="名称" fixed></el-table-column>
        <el-table-column prop="clazzMonitorName" label="班长"></el-table-column>
        <el-table-column prop="clazzTeachers" label="教师"></el-table-column>
        <!-- <el-table-column prop="creatorName" label="创建人"></el-table-column> -->
        <el-table-column prop="createTime" label="创建时间"></el-table-column>
        <!-- 操作列 -->
        <el-table-column label="操作" width="350" fixed="right">
          <template slot-scope="scope">
            <el-button
              type="text"
              icon="el-icon-edit"
              @click="handleEdit(scope.row)"
            >
              编辑
            </el-button>
            <el-button
              type="text"
              icon="el-icon-s-tools"
              style="color: cadetblue"
              @click="handlePromote(scope.row)"
            >
              升班
            </el-button>
            <el-button
              type="text"
              icon="el-icon-upload2"
              @click="handleImport(scope.row)"
            >
              导入
            </el-button>
            <el-button
              type="text"
              icon="el-icon-delete"
              style="color: red"
              @click="handleDelete(scope.row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <pagination-bar
        :total="total"
        :page-size="pageSize"
        :current-page="currentPage"
        @update:pageSize="pageSize = $event"
        @update:currentPage="currentPage = $event"
        @page-change="handleQuery"
      />

      <!-- 编辑/新增弹窗 -->
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="500px"
        @close="handleDialogClose"
      >
        <el-form
          ref="classForm"
          :model="classForm"
          :rules="classFormRules"
          label-width="80px"
        >
          <el-form-item label="名称" prop="name">
            <el-input v-model="classForm.name" placeholder="请输入班级名称" />
          </el-form-item>
          <el-form-item label="年级" prop="gradeId">
            <el-select
              v-model="classForm.gradeId"
              placeholder="请选择年级"
              style="width: 100%"
            >
              <el-option
                v-for="item in gradeOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>

          <el-form-item label="班长" prop="clazzMonitor">
            <el-select
              v-model="classForm.clazzMonitor"
              multiple
              filterable
              placeholder="请选择班长（可多选）"
              style="width: 100%"
            >
              <el-option
                v-for="item in monitorOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="教师" prop="clazzTeachers">
            <el-select
              v-model="classForm.clazzTeachers"
              multiple
              filterable
              placeholder="请选择教师（可多选）"
              style="width: 100%"
            >
              <el-option
                v-for="item in teacherOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitClassForm">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 导入弹窗 -->
      <el-dialog
        title="导入班级信息"
        :visible.sync="importDialogVisible"
        width="500px"
      >
        <el-form label-width="100px">
          <el-form-item label="选择文件">
            <el-upload
              ref="upload"
              :headers="uploadHeaders"
              :action="UPLOAD_URL"
              :auto-upload="false"
              :on-change="handleFileChange"
              :before-upload="beforeUpload"
              :http-request="customUpload"
              :file-list="fileList"
              accept=".xlsx, .xls"
            >
              <el-button slot="trigger" size="small" type="primary"
                >选取文件</el-button
              >
              <div slot="tip" class="el-upload__tip">
                只能上传xlsx/xls文件，且不超过10MB
              </div>
            </el-upload>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="importDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitImport">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 升班弹窗 -->
      <el-dialog
        title="升班"
        :visible.sync="promoteDialogVisible"
        @close="handlePromoteDialogClose"
        width="500px"
      >
        <el-form
          ref="promoteForm"
          :model="promoteForm"
          :rules="promoteFormRules"
          label-width="80px"
        >
          <el-form-item label="新名称" prop="newName">
            <el-input
              v-model="promoteForm.newName"
              placeholder="请输入新班级名称"
            />
          </el-form-item>
          <el-form-item label="新年级" prop="newGrade">
            <el-select
              v-model="promoteForm.newGrade"
              placeholder="请选择新年级"
              style="width: 100%"
            >
              <el-option
                v-for="grade in gradeOptions"
                :key="grade.id"
                :label="grade.name"
                :value="grade.id"
              />
            </el-select>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="promoteDialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="submitPromote">确 定</el-button>
        </span>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import { teacherPage } from "@/api/material";
import {
  clazzPage,
  gradeAll,
  clazzDownloadTemplate,
  clazzAddOrEdit,
  clazzDetail,
  clazzDelete,
  clazzImport,
  clazzUpgrade,
} from "@/api/repair";
import PaginationBar from "@/components/PaginationBar";
import { downloadFile } from "@/utils/util";
import { UPLOAD_URL } from "@/utils/const";
import { getToken } from "@/utils/auth";

export default {
  name: "MaintenanceRecord",
  components: {
    PaginationBar,
  },
  data() {
    return {
      curClazzId: "", //当前需要导入数据的班级
      uploadHeaders: {
        token: getToken(), // 替换为你的 token
      },
      UPLOAD_URL,
      selectedRows: [],
      total: 0,
      pageSize: 10,
      currentPage: 1,
      queryParams: {
        name: "",
      },
      tableData: [],
      // 弹窗相关
      dialogVisible: false,
      importDialogVisible: false,
      dialogTitle: "",
      isEdit: false,
      classForm: {
        gradeId: "",
        name: "",
        clazzMonitor: [], // 改为空数组
        clazzTeachers: [], // 改为空数组
      },
      classFormRules: {
        gradeId: [{ required: true, message: "请输入年级", trigger: "blur" }],
        name: [{ required: true, message: "请输入班级名称", trigger: "blur" }],
        clazzMonitor: [
          {
            required: true,
            validator: (rule, value, callback) => {
              if (!value || value.length === 0) {
                callback(new Error("请选择班长"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
        clazzTeachers: [
          {
            required: false, // 设置为非必填
            validator: (rule, value, callback) => {
              if (value && value.length === 0) {
                // 如果值为空数组，直接通过校验
                callback();
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      },
      fileList: [],
      importFile: null,
      // 升班表单
      promoteForm: {
        id: undefined,
        newName: "",
        newGrade: "",
      },
      // 年级选项
      gradeOptions: [],
      // 班长选项
      monitorOptions: [],
      // 教师选项
      teacherOptions: [],
      promoteDialogVisible: false, // 升班弹窗
      promoteFormRules: {
        newName: [
          { required: true, message: "请输入新班级名称", trigger: "blur" },
        ],
        newGrade: [
          { required: true, message: "请选择新年级", trigger: "change" },
        ],
      },
    };
  },
  created() {
    this.handleQuery(1);
    this.getAllGrade();
    this.getTeacherList();
  },
  methods: {
    // 升班弹窗关闭处理
    handlePromoteDialogClose() {
      // 重置表单校验状态
      if (this.$refs.promoteForm) {
        this.$refs.promoteForm.resetFields();
      }

      // 重置表单数据
      this.promoteForm = {
        id: undefined,
        newName: "",
        newGrade: "",
      };
    },
    // 获取管理老师列表
    getTeacherList() {
      teacherPage({
        pageNo: 1,
        pageSize: 1000,
      }).then((res) => {
        this.monitorOptions = this.teacherOptions = res.records || [];
      });
    },
    getAllGrade() {
      gradeAll().then((res) => {
        this.gradeOptions = res || [];
      });
    },
    handleTabChange(tab) {
      this.state = tab.name; // 更新状态值
      this.currentPage = 1; // 切换状态时重置分页页码
      this.handleQuery();
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      clazzPage({
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
      }).then((res) => {
        this.tableData = res.records;
        this.total = res.total;
      });
    },
    resetQuery() {
      this.queryParams = {
        name: "",
      };
      this.currentPage = 1;
      this.handleQuery();
    },
    // 新增班级
    handleAdd() {
      this.dialogTitle = "新增班级";
      this.isEdit = false;
      this.classForm = {
        gradeId: "",
        name: "",
        clazzMonitor: [], // 改为空数组
        clazzTeachers: [], // 改为空数组
      };
      this.dialogVisible = true;
    },
    // 编辑班级
    // 编辑班级
    handleEdit(row) {
      this.dialogTitle = "编辑班级";
      this.isEdit = true;

      // 获取班级详情
      clazzDetail({
        id: row.id,
      })
        .then((res) => {
          // 提取班长和教师的ID数组
          const clazzMonitorIds = res.clazzMonitors
            ? res.clazzMonitors.map((item) => item.id)
            : [];
          const clazzTeacherIds = res.clazzTeachers
            ? res.clazzTeachers.map((item) => item.id)
            : [];

          // 填充表单数据
          this.classForm = {
            id: res.id,
            gradeId: res.gradeId,
            name: res.name,
            clazzMonitor: clazzMonitorIds,
            clazzTeachers: clazzTeacherIds,
          };

          console.log("填充后的classForm:", this.classForm);
          this.dialogVisible = true;
        })
        .catch((error) => {
          this.$message.error("获取班级详情失败");
        });
    },
    // 升班操作
    handlePromote(row) {
      this.promoteForm.id = row.id;
      this.promoteForm.newName = "";
      this.promoteForm.newGrade = "";
      this.promoteDialogVisible = true;
    },
    // 提交升班表单
    submitPromote() {
      this.$refs.promoteForm.validate((valid) => {
        if (valid) {
          // 调用升班API
          clazzUpgrade({
            id: this.promoteForm.id,
            name: this.promoteForm.newName,
            gradeId: this.promoteForm.newGrade,
          }).then(() => {
            this.$message.success("升班成功");
            this.promoteDialogVisible = false;
            this.handleQuery(this.currentPage);
          });
        }
      });
    },
    // 删除班级
    handleDelete(row) {
      this.$confirm(`确定要删除班级"${row.name}"吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 这里调用删除API
          clazzDelete({
            id: row.id,
          }).then(() => {
            this.$message.success("删除成功");
            this.handleQuery(this.currentPage);
          });
        })
        .catch(() => {
          // 取消操作
        });
    },
    // 导入班级
    handleImport(row) {
      this.importDialogVisible = true;
      this.fileList = [];
      this.importFile = null;
      this.curClazzId = row.id;
    },
    // 下载模板
    downloadTemplate() {
      // 调用下载模板API
      clazzDownloadTemplate().then((res) => {
        downloadFile(res.data, "班级导入模板.xlsx");
      });
    },
    // 上传前验证
    beforeUpload(file) {
      // 获取文件扩展名
      const fileName = file.name;
      const fileExtension = fileName
        .substring(fileName.lastIndexOf("."))
        .toLowerCase();

      // 验证文件类型
      const validExtensions = [".xlsx", ".xls"];

      if (!validExtensions.includes(fileExtension)) {
        this.$message.error("只能上传Excel格式的文件（.xlsx 或 .xls）");
        return false;
      }

      // 验证文件大小（10MB限制）
      const maxSize = 10 * 1024 * 1024; // 10MB
      if (file.size > maxSize) {
        this.$message.error("文件大小不能超过10MB");
        return false;
      }

      return true;
    },
    // 文件选择处理
    handleFileChange(file, fileList) {
      // 验证文件类型
      const isValid = this.beforeUpload(file);
      if (!isValid) {
        // 如果验证不通过，清除文件列表
        this.$refs.upload.clearFiles();
        return false;
      }

      this.importFile = file.raw;
      this.fileList = fileList;
    },
    // 自定义上传方法（不实际上传）
    customUpload() {
      // 空实现，因为我们不希望自动上传
      return false;
    },
    // 提交导入
    submitImport() {
      if (!this.importFile) {
        this.$message.warning("请选择要导入的文件");
        return;
      }

      // 显示加载状态
      const loading = this.$loading({
        lock: true,
        text: "正在导入数据...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      // 创建 FormData 对象
      const formData = new FormData();
      formData.append("file", this.importFile);

      // 调用导入API
      clazzImport(this.curClazzId, formData)
        .then(() => {
          loading.close();
          this.$message.success("导入成功");
          this.importDialogVisible = false;
          this.handleQuery(this.currentPage);
        })
        .catch((error) => {
          loading.close();
          this.$message.error("导入失败: " + (error.message || "未知错误"));
        });
    },
    // 提交班级表单
    submitClassForm() {
      this.$refs.classForm.validate(async (valid) => {
        if (!valid) {
          console.log("表单验证未通过");
          return false;
        }
        console.log("classForm数据:", JSON.stringify(this.classForm));
        try {
          // 调用API提交数据
          await clazzAddOrEdit(this.classForm);

          // 根据操作类型显示成功消息
          const message = this.isEdit ? "编辑成功" : "新增成功";
          this.$message.success(message);

          // 关闭弹窗并刷新数据
          this.dialogVisible = false;
          this.handleQuery(this.currentPage);
        } catch (error) {
          // 根据操作类型显示错误消息
          const action = this.isEdit ? "编辑" : "新增";
          console.error(`${action}失败:`, error);
          this.$message.error(`${action}失败: ${error.message || "未知错误"}`);
        }
      });
    },

    // 弹窗关闭处理
    handleDialogClose() {
      this.$refs.classForm.resetFields();
    },
  },
};
</script>

<style lang="scss" scoped>
.app-container {
}
.el-image {
  cursor: pointer;
}
.el-form-item__content {
  width: 100%;
}
</style>
